import httpManager from "@/app/shared/utils/httpManager";

/**
 * Get submotives from an array of motives
 *
 * @return {Promise<Array>} List of submotives.
 */
export default async function (array) {
  const url = "/entities/submotives/";
  let query = "?";
  if (array.length > 0) {
    array.forEach((id) => {
      query = query + "&motive=" + id;
    });
  }
  const response = await httpManager.get(url + query);

  return response?.data;
}
